export default "__VITE_ASSET__C8GAgXv3__"